import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import RedSocial from './redsocial'
import Menu from './Menu'
// import Media from './Media'
import ColumsContent from './Columns'
import LectorContent from './Lector'
//import logo from './logo.svg';

import { connect } from 'react-redux'
import { initLocation, initCategories, initPostAsync, initPostCountryAsync, initMenuAsync, order, filter, PostPageSearchAsync, PostCategoryAsync, PostCategoryCountryAsync, PostbyTagSlug, postCountrySearchAsync } from './actions'



class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      menu:[],
      article:[],
      loading: true,
      page:1,
      slideObj:[],
      MediaObj:[],
      columnObj:[],
      exludeCat:[7,3,6],
      excludeContry:['VE'],
      excludeCountryID:[19],
      excludeCountryInterID:[22],
      country:'',
      scrolled:0,
      domain: window.location.hostname,
      logo: `${window.location.hostname}/wp-content/themes/beisbolplay/images/logo.png`,
      menuexclude: false,
      menuSel:'',
      termsearch: '',
      idTagExclude: 0,
      loadingico: false,
    }
    this.handlescroll = this.handlescroll.bind(this)
    this.sidebarscroll = this.sidebarscroll.bind(this)
    this.dataFilterSlide = this.dataFilterSlide.bind(this)
    this.dataFilterColumns = this.dataFilterColumns.bind(this)
    this.dataFilterAds = this.dataFilterAds.bind(this)
    this.inputChange = this.inputChange.bind(this)
    this.onclickterm = this.onclickterm.bind(this)
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()
    window.addEventListener('scroll', this.handlescroll)
    window.addEventListener('scroll', this.sidebarscroll)
    this.setState({
      loading: false,
      page: this.state.page + 1
    })

    if(this.props.pageTotal <= this.state.page){
      this.setState({
        loading: false,
        page: this.state.page + 1
      })
    }else{
      this.setState({
        loading: false,
      })
    }

  }

  componentWillReceiveProps(next_props) {

    if(next_props.country.location !== this.state.country){
      // this.props.getAllPostbyCountryInit(this.state.exludeCat, next_props.country.idtag.term_id)
      this.props.getCategorybyCountry(7, next_props.country.idtag.term_id)
      //this.props.getCategorybyCountry(3, next_props.country.idtag.term_id)
      //this.props.getAllTagsbySlug('parrilla-mosaico')
      this.setState({
        country: next_props.country.location,
        menuSel: next_props.country.idtag.slug,
        idTagExclude: next_props.country.idtag.term_id
      });
    }

    if(next_props.post !== this.state.postObj){

      let lectordata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(3) !== -1
      })

      lectordata = lectordata.sort(function(a, b){return b.id-a.id})

      this.setState({
        article: lectordata
      });

      //console.log(next_props)

      let post = next_props.post.filter((itemdata) => {
        //console.log(itemdata.id)
        return itemdata.categories.indexOf(3) === -1 && itemdata.tags.indexOf(12) === -1 && itemdata.tags.indexOf(20) === -1  && itemdata.categories.indexOf(7) === -1
      })

      post = post.sort(function(a, b){return b.id-a.id})

      this.setState({
        postObj: post
      });

      let slidepost = next_props.post.filter(this.dataFilterSlide)

      this.setState({
        slideObj: slidepost.sort(function(a, b){return b.id-a.id})
      });

      // let mediaPost = next_props.post.filter((itemMedia) => {
      //   for (var i = itemMedia.categories.length - 1; i >= 0; i--) {
      //     return itemMedia.categories[i] === 5
      //   }
      //   return true;
      // })

      let mediaPost = next_props.post.filter((itemMedia) => {

        return itemMedia.tags.indexOf(20) !== -1 && itemMedia.tags.indexOf(next_props.country.idtag.term_id) !== -1
      })

      mediaPost = mediaPost.sort(function(a, b){return b.id-a.id})

      if(this.state.MediaObj.length <= mediaPost.length){

        this.setState({
          MediaObj: mediaPost
        });

      }

      let columnPost = next_props.post.filter(this.dataFilterColumns)

      columnPost = columnPost.sort(function(a, b){return b.id-a.id})

      let dat1=this.state.columnObj.length
      let dat2=columnPost.length

      if(dat1 < dat2){
        this.setState({
          columnObj: columnPost
        });
      }
      this.setState({
        loadingico: false
      });
    }
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.handlescroll)
    window.removeEventListener('scroll', this.sidebarscroll)
  }

  dataFilterSlide(value, index){
     for (var i = value.categories.length - 1; i >= 0; i--) {
      if(value.categories[i] === 7 && value.tags.indexOf(20) === -1){
        return true;
      }
    }
    return false;
  }

  dataFilterColumns(value, index){
     for (var i = value.categories.length - 1; i >= 0; i--) {
      if(value.categories[i] === 12){
        return true;
      }
    }
    return false;
  }

  dataFilterAds(i){
    if(i % 10 === 0 && i !== 0){
      return true
    }
    return false
  }


  handlescroll(event){
    if(this.state.loading) return null

    const scrolled = window.scrollY
    const viewportHeight = window.innerHeight
    const fullHeight = document.body.clientHeight

    //console.log(!(scrolled + viewportHeight + 300 >= fullHeight))

    if (!(scrolled + viewportHeight + 300 >= fullHeight)){
      return null
    }
    let pageTotalact = this.props.pageTotal
    if(this.props.pageTotal >= 3){
      pageTotalact = 3
    }

    if(this.state.page <= pageTotalact){
      this.setState({ loading: true}, async () => {
        try{
          this.props.getPagePostSearch(this.state.page, this.state.termsearch, this.state.idTagExclude)
          this.setState({
            loading: false,
            page: this.state.page + 1
          })
        }
        catch (error){
          this.setState({ loading: false })
        }
      })
    }
  }

  sidebarscroll(event){
    if(this.state.loading) return null
    const scrolled = window.scrollY
    const viewportHeight = window.innerHeight
    const fullHeight = document.body.clientHeight
    const fullWidth = document.body.clientWidth
    const sidebarHeight = (typeof document.body.getElementsByClassName('sidebar__inner')[0] !== 'undefined')? document.body.getElementsByClassName('sidebar__inner')[0].clientHeight : 0
    const footerHeight = (typeof document.body.getElementsByClassName('page-footer')[0] !== 'undefined')? document.body.getElementsByClassName('page-footer')[0].clientHeight : 0
    const sidebarPost = (typeof document.body.getElementsByClassName('sidebar')[0] !== 'undefined')? document.body.getElementsByClassName('sidebar')[0].offsetTop : 0
    const totalPost = sidebarPost + sidebarHeight
    const viewHeigth = scrolled + viewportHeight
    const viewWindow = (fullHeight - footerHeight) - 200

    if(fullWidth > 430){

      if (!(scrolled + viewportHeight >= totalPost)){
        return null
      }

      if(viewHeigth >= totalPost && viewHeigth < viewWindow){
        let topNumber = viewHeigth - totalPost;
        document.body.getElementsByClassName('sidebar__inner')[0].style.top = `${topNumber}px`
      }
    }
  }

  inputChange (e) {
    this.setState({
      termsearch: e.target.value,
      postObj: []
    });
  }

  onclickterm(){
    this.props.getSearch(this.state.termsearch, this.state.idTagExclude)
    this.setState({
      loadingico: true,
    });
  }

  render() {
    return (
      <div>
        <div className="ads-one hide-on-small-only hide-on-med-and-up">
          {/* <DFPSlotsProvider dfpNetworkId='22167442' collapseEmptyDivs={true}>
            <div className="ad-slot-4">
              <AdSlot sizes={[1, 1]} adUnit="IVC/IVC_Native_1x1" shouldRefresh={ ()=> false }/>
            </div>
          </DFPSlotsProvider> */}
        </div>
        <div className="section no-pad-bot" id="banner-up-tag">
          <div className="container">
            {/* <DFPSlotsProvider dfpNetworkId='22167442'
                sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [970, 90]]},
                                {viewport: [320, 400], sizes:[[300, 50],[320,50],[300,100]] },
                                {viewport: [750, 200], sizes:[[728,90]] }] } collapseEmptyDivs={true}>
              <div className="ad-slot-1">
                <AdSlot sizes={[[300, 50], [970, 90], [320, 50], [300, 100], [728, 90]]} adUnit="IVC/IVC_leaderlboard_1_ATF" />
              </div>
            </DFPSlotsProvider> */}
          </div>
        </div>
        <div className="cont-nav">
          <div className="lighten-1 hide-on-med-only">
            <div className="nav-wrapper container">
              <div className="row">
                <div className="col s6 offset-s6 right-align social-ico">
                  <RedSocial />
                </div>
              </div>
            </div>
          </div>
          <nav className="lighten-nav"  >
            <div className="nav-wrapper container">
              <Menu slug={this.state.menuSel}/>
            </div>
          </nav>
        </div>
        <div className="section cont-media">
          <div className="container">
            <div className="row">
              <div className="section no-pad-bot" id="banner-up-tag">
                <div className="container">
                  {/* <DFPSlotsProvider dfpNetworkId='22167442'
                sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [970, 90]]},
                                {viewport: [320, 400], sizes:[[300, 50],[320,50],[300,100]] },
                                {viewport: [750, 200], sizes:[[728,90]] }] } collapseEmptyDivs={true}>
              <div className="ad-slot-2">
                <AdSlot sizes={[[300, 50], [970, 90], [320, 50], [300, 100], [728, 90]]} adUnit="IVC/IVC_leaderlboard_2_ATF" />
              </div>
            </DFPSlotsProvider> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={(this.state.postObj.length > 0) ? 'search_data_post': 'search_data_post search_data'}>
          <div className="container">
            <div className="row">
              <div className="col s12 offset-m3 m6 offset-l3 l6">
                <div className="col s10 int">
                  <input type="text" onChange={this.inputChange} />
                </div>
                <div className="col s2 btn">
                 <button type="button" onClick={this.onclickterm} >
                  <div>
                    { !this.state.loadingico &&
                      <div>
                        <i className="fas fa-search" />
                      </div>
                    }
                    { this.state.loadingico &&
                      <div className="preloader-wrapper small active">
                        <div className="spinner-layer spinner-white-only">
                          <div className="circle-clipper left">
                            <div className="circle"></div>
                          </div><div className="gap-patch">
                            <div className="circle"></div>
                          </div><div className="circle-clipper right">
                            <div className="circle"></div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.postObj.length > 0 &&
          <div className="section cont-post">
            <div className="container main-content">
              <div className="row">
                <div className="col s12 m7 l8">
                  <div className="result_term">
                    <h4>Resultados para {this.state.termsearch}</h4>
                  </div>
                  {
                    this.state.postObj.map((item, i) => {
                      const urlcat = `category/${item.categoryname_field}`
                      let adsItem = this.dataFilterAds(i)
                      return (
                        <div className="item-post" key={i}>
                          <div className="row">
                          { item.featured_media > 0 &&
                            <div className="col s12 m4 l4">
                              <div className={(item.video_field.length > 0) ? 'item-post-img-play' : 'item-post-img'}>
                                {
                                  item.media.media_details.sizes.medium && item.media.media_details.sizes.medium.source_url &&
                                  <a href={item.link}><img src={item.media.media_details.sizes.medium.source_url} alt=""/></a>
                                }
                              </div>
                            </div>
                          }
                          { item.featured_media > 0 &&
                            <div className="col s12 m8 l8">
                              <div className="item-post-date">
                                <a href={urlcat}><p className={item.categoryname_field}>{item.categoryname_field}</p></a>
                              </div>
                              <div className="item-post-title">
                                <a href={item.link}><h3>{renderHTML(item.title.rendered)}</h3></a>
                              </div>
                              <div className="item-post-cont">
                                <div>{renderHTML(item.excerpt.rendered)}</div>
                              </div>
                            </div>
                          }
                          { item.featured_media === 0 &&
                            <div className="col s12 m12 l12">
                              <div className="item-post-date">
                                <a href={urlcat}><p className={item.categoryname_field}>{item.categoryname_field}</p></a>
                              </div>
                              <div className="itemm-post-title">
                                <h3>{renderHTML(item.title.rendered)}</h3>
                              </div>
                              <div className="item-post-cont">
                                <div>{renderHTML(item.excerpt.rendered)}</div>
                              </div>
                            </div>
                          }

                          </div>
                          {
                            adsItem &&
                              <div className="ads-row">
                                {/* <DFPSlotsProvider dfpNetworkId='22167442'
                                  sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90]]},
                                                  {viewport: [320, 400], sizes:[[320,50],[300,100]] },
                                                  {viewport: [750, 200], sizes:[[640,100]] }] } collapseEmptyDivs={true}>
                                  <div className={`id-tag-${item.id}`}>
                                    <AdSlot sizes={[[320, 50], [320, 100]]} adUnit="IVC/IVC_leaderlboard_3" />
                                  </div>
                                </DFPSlotsProvider> */}
                              </div>
                          }
                        </div>
                      )
                    })
                  }
                </div>
                <div className="col s12 m5 l4 sidebar">
                  <div className="sidebar__inner">
                    <div className="tagtwo">
                      <div className="container">
                         {/* <DFPSlotsProvider dfpNetworkId='22167442' collapseEmptyDivs={true}>
                            <div className="ad-slot-3">
                              <AdSlot sizes={[[300, 300], [300, 600], [300, 250]]} adUnit="IVC/IVC_mediumrectangle_1_ATF" />
                            </div>
                          </DFPSlotsProvider> */}
                      </div>
                    </div>

                    <ColumsContent colObj={this.state.columnObj.slice(0, 3)}/>
                    <LectorContent lector={this.state.article.slice(0, 3)}/>
                    <div className="tagthree">
                      <div className="container">
                        {/* <DFPSlotsProvider dfpNetworkId='22167442' collapseEmptyDivs={true}>
                            <div className="ad-slot-5">
                              <AdSlot sizes={[[300, 300], [300, 600], [300, 250]]} adUnit="IVC/IVC_mediumrectangle_2_ATF" />
                            </div>
                          </DFPSlotsProvider> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="ads-row">
                  {/* <DFPSlotsProvider dfpNetworkId='22167442'
                    sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90]]},
                                    {viewport: [320, 400], sizes:[[320,50],[300,100]] },
                                    {viewport: [750, 200], sizes:[[640,100]] }] } collapseEmptyDivs={true}>
                    <div className="footer-ads">
                      <AdSlot sizes={[[320, 50], [320, 100], [728, 90], [640, 100]]} adUnit="BeisbolPlay/BP_leaderlboard_3" />
                    </div>
                  </DFPSlotsProvider> */}
                </div>
              </div>
            </div>
          </div>
        }
        <footer className="page-footer">
          <div className="container">
            <div className="row">
              <div className="col s12 m3 l3 cont-logo">
                <a id="logo-container" href="/" className="brand-logo">
                  <img src="/wp-content/themes/ivc/images/logo_footer.png" alt=""/>
                </a>
              </div>
              <div className="col s12 m9 l9 right-align social-ico">
                <RedSocial />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m4 l4 cont-logo-ter">
                <ul>
                  <li className="col s12 m7 l7"><a href="/terms-and-conditions/">TERMINOS DE USO</a></li>
                  <li className="col s12 m5 l5"><a href="/contacto">CONTACTO</a></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    pageTotal: reducer.page,
    post: reducer.post,
    menus: reducer.menus,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAllCategoryInit: (data) => dispatch(initCategories(data)),
    getAllPostInit: (data) => dispatch(initPostAsync(data)),
    getAllPostbyCountryInit: (data, excludeContry) => dispatch(initPostCountryAsync(data, excludeContry)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getCategory: (data) => dispatch(PostCategoryAsync(data)),
    getCategorybyCountry: (data, excludeCountry) => dispatch(PostCategoryCountryAsync(data, excludeCountry)),
    filterBy: (data) => dispatch(filter(data)),
    orderBy: (data) => dispatch(order(data)),
    getAllTagsbySlug: (data) => dispatch(PostbyTagSlug(data)),
    getSearch: (data, excludeCountry) => dispatch(postCountrySearchAsync(data, excludeCountry)),
    getPagePostSearch: (data, string, country) => dispatch(PostPageSearchAsync(data, string, country)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(App)



// WEBPACK FOOTER //
// ./src/Search.js